import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UserOnBoardingRoutingModule } from './user-on-boarding-routing.module';
import { LoginComponent } from './containers/login/login.component';
import { SharedModule } from '../shared';
import { StoreModule } from '@ngrx/store';
import { reducer } from './store/account-login/account-login.reducers';
import { CreateAccountComponent } from './containers/create-account/create-account.component';
import { VerifyComponent } from './containers/verify/verify.component';
import { AccountLoginService } from './services/account-login.service';
import { GuestOnlyGuard } from '@app/services/guest-only.guard';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzResultModule } from 'ng-zorro-antd/result';
import { ResetPasswordComponent } from './containers/reset-password/reset-password.component';
import { SetPasswordComponent } from './containers/set-password/set-password.component';
import { AddressGroupComponent } from './components/address-group/address-group.component';
import { RegistrationDisabledComponent } from './containers/registration-disabled/registration-disabled.component';
import { MatInputModule } from '@angular/material/input';
import { MatFormField } from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MaskitoDirective } from '@maskito/angular';
import {
    RegistrationSuccessfulComponent
} from '@app/user-on-boarding/containers/registration-successful/registration-successful.component';

@NgModule({
    imports: [
        CommonModule,
        UserOnBoardingRoutingModule,
        StoreModule.forFeature('accountLogin', reducer),
        SharedModule,
        NzFormModule,
        NzCardModule,
        NzGridModule,
        NzAlertModule,
        NzInputModule,
        NzDividerModule,
        NzPopoverModule,
        NzResultModule,
        MatInputModule,
        MatFormField,
        MatAutocompleteModule,
        MatSelectModule,
        MatIconModule,
        MatButtonModule,
        MaskitoDirective
    ],
    declarations: [
        LoginComponent,
        ResetPasswordComponent,
        SetPasswordComponent,
        CreateAccountComponent,
        VerifyComponent,
        AddressGroupComponent,
        RegistrationDisabledComponent,
        RegistrationSuccessfulComponent
    ],
    providers: [
        AccountLoginService,
        GuestOnlyGuard
    ]
})
export class UserOnBoardingModule {
}
